import _filter from 'lodash/filter';
import _uniqBy from 'lodash/uniqBy';
import _find from 'lodash/find';
import moment from 'moment';

const NYC_CITY_ID = 'aa211bf5d25100ac';
const BOSTON_CITY_ID = '301072f4d252999a'; //e9f8eb4b2b821e20
const CHICAGO_CITY_ID = '11abc446a23da51a';
const FOXWOODS_CITY_ID = '568778505711d1b2';
const FORT_LAUDERDALE_CITY_ID = 'xxx';
const LA_CITY_ID = 'f9fce97fa9132e52';
const MIAMI_CITY_ID = '62c929d5af07ce54';
const PHILLY_CITY_ID = '9ceeab229a24e62d';
const DETROIT_CITY_ID = 'f552cfc2b2535d0e';
const SAN_ANTONIO_CITY_ID = 'cb453f5710bf9950';
const HONOLULU_CITY_ID = '6a38221d87f63fbd';
const HOUSTON_CITY_ID = 'f571681b2ff72d5c';
const LAS_VEGAS_CITY_ID = 'cd2018d3f09c6ea9';
const ANAHEIM_CITY_ID = '9ce1109aa47913bb';
// const WHISTLER_CITY_ID = '6fec4941d2c526ea';
// const ATLANTIC_CITY_CITY_ID = '647c7b01d5fc056a';
const DALLAS_CITY_ID = '2a5304c583e1a75e';
// const LOS_ANGELES_CITY_ID = 'f9fce97fa9132e52';
const SAN_DIEGO_CITY_ID = 'b5ed38b8d630d9dc';
const SEATTLE_ID = 'ae509095e188297c';
const SAN_FRANCISCO_CITY_ID = '5037331a71b485ee';
const SCOTTSDALE_CITY_ID = 'bcdfa9e13bbb3f46';
const TAMPA_CITY_ID = '2f15e73a5e960cf9';
const AUSTIN_CITY_ID = 'abd97a4fd8b43635';
const ASPEN_CITY_ID = 'e908312b03c42d5b';
const WASHINGTON_DC_CITY_ID = '070ac346cd2d446f';

const PROD_CURATED_LISTS_BY_CITY_ID = {
  [NYC_CITY_ID]: '270aac8a9eab2d68',
  [BOSTON_CITY_ID]: 'e9f8eb4b2b821e20',
  [CHICAGO_CITY_ID]: 'd303343d43ccc321',
  [FOXWOODS_CITY_ID]: '6fbf6cf3510fb223',
  [FORT_LAUDERDALE_CITY_ID]: 'fb4fc0762316dd0c',
  [LA_CITY_ID]: 'f8e216e4a0951aa5',
  [MIAMI_CITY_ID]: 'd680f3873b5475cb',
  [PHILLY_CITY_ID]: '4a5d0e43ad1722f5',
  [DETROIT_CITY_ID]: '65b5a0e1aded5c7c',
  [SAN_ANTONIO_CITY_ID]: '8ce2c846ecbb0db8',
  [HONOLULU_CITY_ID]: '562d0804f0b09b98',
  [HOUSTON_CITY_ID]: 'e57d1dea6b87868a',
  [LAS_VEGAS_CITY_ID]: 'ed6e43f2224ff19f',
  [ANAHEIM_CITY_ID]: 'ef2a5d67d434a0e4',
  // [WHISTLER_CITY_ID]: 'aa418054c910bc88',
  // [ATLANTIC_CITY_CITY_ID]: '78c595923ea6cb5f',
  [DALLAS_CITY_ID]: 'db6a96a4b058fb7c',
  // [LOS_ANGELES_CITY_ID]: '33302c7aaee75be6',
  [SAN_DIEGO_CITY_ID]: 'e40ee1a7e79e1c9a',
  [SEATTLE_ID]: '1df7f70e1bc8cfbf',
  [SAN_FRANCISCO_CITY_ID]: 'c650612af4d39c0a',
  [SCOTTSDALE_CITY_ID]: '847e6d07ecb0c3cb',
  [TAMPA_CITY_ID]: 'cabe83f05227ce72',
  [AUSTIN_CITY_ID]: '85586eaa6b8bfc85',
  [ASPEN_CITY_ID]: '5445b0bb031b4ebc',
  [WASHINGTON_DC_CITY_ID]: '48980046e68980c7'
};

const EVENT_ENABLED = true;
const TODAYS_DATE = moment();
const EVENT_DATE = moment().endOf('year');

// console.log('TODAYS_DATE', TODAYS_DATE.toISOString());
// console.log('EVENT_DATE', EVENT_DATE.toISOString());

function Ctrl(
  $rootScope,
  $scope,
  $state,
  $timeout,
  $stateParams,
  $document,
  $location,
  $q,
  metaTagService,
  utilsService,
  jsSdkUser,
  tlEE,
  jsSdkCuratedList,
  jsSdkCuratedListFollow,
  jsSdkCity,
  imgix
) {
  //eslint-disable-line

  $scope.saving = false;
  $scope.curatedList = null;
  $scope.items = [];
  $scope.currentVenueFilter = null;
  $scope.cityForm = {};
  $scope.currentYear = new Date().getFullYear();

  const PROD_CITY_IDS = Object.keys(PROD_CURATED_LISTS_BY_CITY_ID);

  const citySlug = $stateParams.city || utilsService.defaultCitySlug();

  // ---------------------- //
  $scope.showCountdown = !EVENT_ENABLED;

  const diff = TODAYS_DATE.diff(EVENT_DATE, 'days');

  if (diff > 0) {
    EVENT_DATE.add(1, 'year');

    $scope.eventPast = true;
  }

  $scope.eventDate = EVENT_DATE;
  // ---------------------- //

  jsSdkCity.list().then((cities) => {
    $scope.cities = _filter(cities, (city) => PROD_CITY_IDS.includes(city.id));

    $scope.cityForm.city =
      _find($scope.cities, {
        slugName: citySlug || 'nyc'
      }) || $scope.cities[0];

    $scope.selectCity();
  });

  $scope.selectCity = function () {
    console.log('$scope.cityForm', $scope.cityForm);

    console.log(
      'PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]',
      PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]
    );

    $state.go($state.current.name, {
      city: $scope.cityForm.city.slugName
    });

    if (PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]) {
      return _loadCuratedList(
        PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]
      );
    }

    return null;
  };

  $scope.imgix = function (src) {
    const options = {
      width: 1200,
      height: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.toggleCurrentVenue = function (venue) {
    if (
      $scope.currentVenueFilter &&
      $scope.currentVenueFilter.id === venue.id
    ) {
      $scope.currentVenueFilter = null;
    } else {
      $scope.currentVenueFilter = venue;
    }
  };

  $scope.filterByCurrentVenue = function (item) {
    if (!$scope.currentVenueFilter) {
      return true;
    } else if ($scope.currentVenueFilter.id === item.venue.id) {
      return true;
    }

    return false;
  };

  function _loadCuratedList(id) {
    $scope.loading = true;

    const options = {
      items: true,
      follow: true,
      fields: [
        'venue(id, name)',
        'event(id, name, date, images, primaryImage, dateStart, dateEnd)'
      ].join(',')
    };

    return jsSdkCuratedList
      .readById(id, options)
      .then((resp) => {
        $scope.curatedList = resp;
        $scope.items = resp.items;

        const eventItems = _filter($scope.items, {
          type: 'EVENT'
        });

        $scope.venues = _uniqBy(
          eventItems.map((item) => item.venue),
          (venue) => venue.id
        );

        metaTagService.set({
          title: resp.title,
          description: resp.description,
          facebookImage: resp.imageUrl
        });

        $scope.shareBarConfig = {
          url: utilsService.createUrl(`/list/${$scope.curatedList.id}`),
          message: `See Tablelist's - ${$scope.curatedList.title}`
        };

        const url = utilsService.createUrl(`/list/${$scope.curatedList.id}`);
        const msg = `See Tablelist's - ${$scope.curatedList.title}`;

        $scope.facebookLink = utilsService.facebookLink(url);
        $scope.twitterLink = utilsService.twitterLink(url, msg);
        $scope.emailLink = utilsService.mailtoLink(url, msg);

        $scope.loading = false;
        $scope.saving = false;
      })
      .catch(() => {
        $scope.loading = false;
        $scope.saving = false;
      });
  }
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$timeout',
  '$stateParams',
  '$document',
  '$location',
  '$q',
  'metaTagService',
  'utilsService',
  'jsSdk.user',
  'tl.ee',
  'jsSdk.curatedList',
  'jsSdk.curatedListFollow',
  'jsSdk.city',
  'jsSdk.imgix',
  'loggerService',
  'trackingService',
  'tl.config',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/curatedListsNewYears/curatedListsNewYearsCtrl.js